import { IDmHe } from "../../model/respone/category/IDmHe";
import { apiClient } from "../apiClient";
export const HE_ENDPOINT = "he";
export const heApi = {
  SelectAll: () => apiClient.get(`${HE_ENDPOINT}`),
  Insert: (payload: IDmHe) => apiClient.post(`${HE_ENDPOINT}`, payload),
  Update: (payload: IDmHe) => apiClient.put(`${HE_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${HE_ENDPOINT}/${id}`),
};
